import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: { full_name: '' },
  authToken: null,
};

export const userDataSlice = createSlice({
  name: 'setUser',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    clearUser: (state) => {
      state.user = {};
    },
    setAuthToken: (state, action) => {
      state.authToken = action.payload;
    },
  },
});

export const { setUser, clearUser, setAuthToken } = userDataSlice.actions;

export default userDataSlice.reducer;
